import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.calendar');
import { OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface CalEvent {
    id: string;
    title: string;
    start_at: string;
    end_at: string;
    all_day: boolean;
    color: string;
    type: string;
    location?: string;
    description?: string;
    workspace_id?: string;
}

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-calendar',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.calendar/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabCalendarComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() workspace_id: string = '';

    public events: CalEvent[] = [];
    public me: string = '';
    public viewMode: 'month' | 'week' | 'list' = 'month';
    public cursor: Date = new Date();
    public loaded: boolean = false;

    public showForm: boolean = false;
    public editing: any = null;
    public form: any = this._emptyForm();

    public showDetail: boolean = false;
    public detail: any = null;

    public colors: string[] = ['rose', 'amber', 'emerald', 'sky', 'violet', 'zinc'];
    public typeLabels: any = {
        event: '일정', meeting: '회의', deadline: '마감', birthday: '기념일', task: '업무',
    };

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async ngOnChanges(c: SimpleChanges) {
        if (c['workspace_id'] && !c['workspace_id'].firstChange) {
            await this.load();
        }
    }

    private _emptyForm(): any {
        const now = new Date();
        const pad = (n: number) => String(n).padStart(2, '0');
        const fmt = (d: Date) =>
            `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
        return {
            title: '', description: '',
            start_at: fmt(now),
            end_at: fmt(new Date(now.getTime() + 3600 * 1000)),
            all_day: '0',
            location: '', online_link: '',
            color: 'rose', type: 'event',
            attendees: '',
        };
    }

    private _range(): { start: string, end: string } {
        const c = new Date(this.cursor);
        let s: Date, e: Date;
        if (this.viewMode === 'month') {
            s = new Date(c.getFullYear(), c.getMonth() - 1, 1);
            e = new Date(c.getFullYear(), c.getMonth() + 2, 0, 23, 59, 59);
        } else if (this.viewMode === 'week') {
            const dow = c.getDay();
            s = new Date(c.getFullYear(), c.getMonth(), c.getDate() - dow);
            e = new Date(s.getTime() + 7 * 86400 * 1000);
        } else {
            s = new Date(c.getFullYear(), c.getMonth() - 6, 1);
            e = new Date(c.getFullYear(), c.getMonth() + 7, 0, 23, 59, 59);
        }
        const iso = (d: Date) => d.toISOString().slice(0, 19).replace('T', ' ');
        return { start: iso(s), end: iso(e) };
    }

    public async load() {
        const { start, end } = this._range();
        const params: any = { start, end };
        if (this.workspace_id) params.workspace_id = this.workspace_id;
        const res = await wiz.call("list_events", params);
        if (res.code === 200) {
            this.events = res.data.rows || [];
            this.me = res.data.me;
        }
        this.loaded = true;
        await this.service.render();
    }

    public navigate(delta: number) {
        const c = new Date(this.cursor);
        if (this.viewMode === 'month') {
            c.setMonth(c.getMonth() + delta);
        } else if (this.viewMode === 'week') {
            c.setDate(c.getDate() + 7 * delta);
        } else {
            c.setMonth(c.getMonth() + delta);
        }
        this.cursor = c;
        this.load();
    }

    public goToday() {
        this.cursor = new Date();
        this.load();
    }

    public async setView(mode: any) {
        this.viewMode = mode;
        await this.load();
    }

    // -------- month grid helpers
    public get monthGrid(): Date[][] {
        const c = this.cursor;
        const first = new Date(c.getFullYear(), c.getMonth(), 1);
        const start = new Date(first);
        start.setDate(1 - first.getDay());
        const weeks: Date[][] = [];
        for (let w = 0; w < 6; w++) {
            const week: Date[] = [];
            for (let d = 0; d < 7; d++) {
                const day = new Date(start);
                day.setDate(start.getDate() + w * 7 + d);
                week.push(day);
            }
            weeks.push(week);
        }
        return weeks;
    }

    public eventsOn(day: Date): CalEvent[] {
        const ymd = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;
        return this.events.filter(e => {
            const s = (e.start_at || '').slice(0, 10);
            const en = (e.end_at || s).slice(0, 10);
            return ymd >= s && ymd <= en;
        });
    }

    public isToday(d: Date): boolean {
        const t = new Date();
        return d.getFullYear() === t.getFullYear() &&
            d.getMonth() === t.getMonth() && d.getDate() === t.getDate();
    }

    public isCurrentMonth(d: Date): boolean {
        return d.getMonth() === this.cursor.getMonth();
    }

    public colorBg(c: string): string {
        const m: any = {
            rose: 'bg-rose-100 text-rose-700',
            amber: 'bg-amber-100 text-amber-700',
            emerald: 'bg-emerald-100 text-emerald-700',
            sky: 'bg-sky-100 text-sky-700',
            violet: 'bg-violet-100 text-violet-700',
            zinc: 'bg-zinc-100 text-zinc-700',
        };
        return m[c] || m.rose;
    }

    public colorDot(c: string): string {
        const m: any = {
            rose: 'bg-rose-500', amber: 'bg-amber-500', emerald: 'bg-emerald-500',
            sky: 'bg-sky-500', violet: 'bg-violet-500', zinc: 'bg-zinc-500',
        };
        return m[c] || m.rose;
    }

    // -------- form
    public openCreate(day: Date | null = null) {
        this.editing = null;
        this.form = this._emptyForm();
        if (day) {
            const pad = (n: number) => String(n).padStart(2, '0');
            const ymd = `${day.getFullYear()}-${pad(day.getMonth() + 1)}-${pad(day.getDate())}`;
            this.form.start_at = `${ymd}T09:00`;
            this.form.end_at = `${ymd}T10:00`;
        }
        this.showForm = true;
    }

    public async openDetail(e: CalEvent, ev?: Event) {
        if (ev) ev.stopPropagation();
        const res = await wiz.call("detail", { id: e.id });
        if (res.code === 200) {
            this.detail = res.data.event;
            this.showDetail = true;
            await this.service.render();
        }
    }

    public openEdit() {
        if (!this.detail) return;
        const e = this.detail;
        this.editing = e;
        this.form = {
            title: e.title || '',
            description: e.description || '',
            start_at: (e.start_at || '').replace(' ', 'T').slice(0, 16),
            end_at: (e.end_at || '').replace(' ', 'T').slice(0, 16),
            all_day: e.all_day ? '1' : '0',
            location: e.location || '',
            online_link: e.online_link || '',
            color: e.color || 'rose',
            type: e.type || 'event',
            attendees: (e.attendees || []).map((a: any) => a.user_id).join(','),
        };
        this.showDetail = false;
        this.showForm = true;
    }

    public async submit() {
        if (!this.form.title?.trim()) {
            this.service.alert.error('제목을 입력하세요.');
            return;
        }
        const payload: any = { ...this.form };
        payload.start_at = payload.start_at.replace('T', ' ') + ':00';
        payload.end_at = payload.end_at.replace('T', ' ') + ':00';
        if (this.workspace_id) payload.workspace_id = this.workspace_id;
        let res;
        if (this.editing) {
            payload.id = this.editing.id;
            res = await wiz.call("update", payload);
        } else {
            res = await wiz.call("create", payload);
        }
        if (res.code === 200) {
            this.showForm = false;
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || '저장 실패');
        }
    }

    public async remove() {
        if (!this.detail || !confirm('이 일정을 삭제하시겠습니까?')) return;
        const res = await wiz.call("remove", { id: this.detail.id });
        if (res.code === 200) {
            this.showDetail = false;
            this.detail = null;
            await this.load();
        }
    }

    public async respond(status: string) {
        if (!this.detail) return;
        const res = await wiz.call("respond", { id: this.detail.id, status });
        if (res.code === 200) {
            await this.openDetail(this.detail);
        }
    }

    public get title(): string {
        const c = this.cursor;
        if (this.viewMode === 'month') {
            return `${c.getFullYear()}년 ${c.getMonth() + 1}월`;
        }
        if (this.viewMode === 'week') {
            const s = new Date(c); s.setDate(s.getDate() - s.getDay());
            const e = new Date(s); e.setDate(e.getDate() + 6);
            return `${s.getMonth() + 1}/${s.getDate()} – ${e.getMonth() + 1}/${e.getDate()}`;
        }
        return `${c.getFullYear()}년 ${c.getMonth() + 1}월 (목록)`;
    }

    public get listEvents(): CalEvent[] {
        return [...this.events].sort((a, b) =>
            (a.start_at || '').localeCompare(b.start_at || ''));
    }

    public dayHeaders: string[] = ['일', '월', '화', '수', '목', '금', '토'];
}

export default PortalLpsysadminCollabCalendarComponent;